import { Drawer as AntDrawer } from 'antd';

export default function Drawer({ open, onClose, children }) {
  return (
    <AntDrawer
      className="!bg-[#F3F8FF] rounded-s-[10px]"
      placement="right"
      closable={false}
      onClose={onClose}
      open={open}
      width={515}
    >
      {children}
    </AntDrawer>
  );
}
